<template>
  <b-card :title="$t('posts') + ' (' + posts.length + ')'" class="mb-4">
    <div class="posts-container" ref="postsContainer">
      <Posts
        :posts="posts"
        :deleteable="true"
        :user="getCurrentUser"
        v-on:comment:post="onCreatePost($event, project.id)"
        v-on:comment:delete="onDeletePost($event, project.id)"
      />
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Posts from '@/components/Posts';

export default {
  components: {
    Posts,
  },
  props: {
    project: { type: Object },
    projectNumber: null,
  },
  data() {
    return {
      pollingInterval: null,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAdmin', 'isClient', 'getCurrentUser']),

    /**
     * Get all post from project
     */
    posts() {
      if (this.project.posts) {
        return this.project.posts;
      }
      return [];
    },
  },
  // watch: {
  //   /**
  //    * Scroll to bottom when posts change
  //    */
  //   posts: {
  //     handler() {
  //       this.$nextTick(() => {
  //         this.scrollToBottom();
  //       });
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    ...mapActions(['fetchPostsOfProjectByNumber', 'addPostToProject', 'deletePostFromProject']),

    /**
     * Create a post assigned to the project
     */
    onCreatePost(post) {
      this.addPostToProject({
        content: post,
        user: this.getCurrentUser.id,
        project: this.project.id,
      });
    },

    /**
     * Delete a post
     */
    onDeletePost(postId, projectId) {
      this.deletePostFromProject({ postId: postId, projectId: projectId });
    },

    /**
     * Fetch posts of the project every 25 seconds
     */
    startPolling() {
      this.pollingInterval = setInterval(async () => {
        await this.fetchPostsOfProjectByNumber(this.project.number);
      }, 30000);
    },

    /**
     * Stop polling when component is destroyed
     */
    stopPolling() {
      clearInterval(this.pollingInterval);
    },

    /**
     * Scroll to bottom of posts container
     */
    scrollToBottom() {
      if (this.$refs.postsContainer) {
        this.$refs.postsContainer.scrollTop = this.$refs.postsContainer.scrollHeight;
      }
    },
  },
  mounted() {
    if (this.project.number && this.project.number !== '_new') {
      this.startPolling();
    }

    // Scroll to bottom when component is mounted
    this.$nextTick(() => {
      this.scrollToBottom();
    });
  },
  beforeDestroy() {
    this.stopPolling();
  },
};
</script>

<style scoped lang="scss">
.posts-container {
  max-height: 370px;
  overflow-y: auto;
  padding-right: 0.5rem;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}
</style>
